import React from "react";
import { Typography } from "@material-ui/core";
import { TextField } from "react-admin";
import { Link as RouterLink } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";

const useComentarioStyles = makeStyles({
  clamp: {
    display: "-webkit-box",
    "-webkit-line-clamp": 3,
    "-webkit-box-orient": "vertical",
    overflow: "hidden",
  },
});

const LogActivityContactoExterno = ({ record: registro }) => {
  const classes = useComentarioStyles();
  return registro ? (
    <>
      <Typography
        variant="body2"
        gutterBottom
        component={RouterLink}
        to={`/comentarios/${registro.id}`}
        style={{ textDecoration: "none" }}
      >
        {`Contacto externo escrito por el usuario `}
        &nbsp;[
        {registro.user ? (
          <TextField source="user.name" label="" record={registro} />
        ) : (
          `desconocido`
        )}
        ]&nbsp;
        {`mediante`}&nbsp;[
        <TextField source="mediodecontacto.nombre" label="" record={registro} />
        ]
      </Typography>
      <Typography
        variant="body2"
        color="textSecondary"
        gutterBottom
      ></Typography>
      <Typography
        variant="body2"
        color="textSecondary"
        className={classes.clamp}
      >
        {registro.texto}
      </Typography>
    </>
  ) : null;
};
export default LogActivityContactoExterno;
